// John Eldhose 20180523
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Button, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Grid, IconButton, List, ListItem, ListItemText, Paper, Snackbar, Typography } from '@material-ui/core';
import { Cancel, Done, ExpandMore, Send } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import ReactTable from "react-table";
import "react-table/react-table.css";
import { myProducts } from '../../Api/myProducts';
import { upgradedFrom } from '../../Api/upgradedFrom';
import { getRegistration } from '../../Api/getRegistration';
import { connect } from 'react-redux';
import AddToCart from '../../actions/AddToCart';
import Subscription from '../lib/Subscription';

const columns = [
  {Header: "Product", accessor: "PRODUCTNAME", className: "MyProductsHeader"},
  {Header: "Serial Number", accessor: 'SERIALNUM', className: "MyProductsHeader"},
  {Header: "Expiration", accessor: "EXPIRY_DATE", width: 120},
  {Header: "Download", accessor: "download", className: "MyProductsHeader", width: 110, sortable: false, Cell: row =><a href={row.value} target="_blank">Download</a>}
];

class App extends Component {

  state = {
    data: [],
    pages: null,
    loading: true,
    cart: {},
    Message: '',
    errorMessage: '',
    pedigree: {},
    registration: {},
    sum: 0,
    subscribe: null
  };
  fetchData = (state, instance) => {
    if(state.sorted.length === 0)
      state.sorted[0] = {id: 'EXPIRY_DATE', desc: true};
    this.setState({ loading: true });
    myProducts(state.pageSize, state.page, state.sorted)
      .then((prod) => {
        if(prod['status'] === 'true') {
          var sum = 0;
          for(var i = 0; i < prod['data'].length; i++)
            if(
              prod.data[i].current === 'false' &&
              typeof prod.data[i].maintenance === 'number'
            )
              sum += prod.data[i].maintenance
          this.setState({
            pages: prod['pages'], data: prod['data'], loading: false, sum: sum
          });
        }
      })
      .catch((error) => {
        console.log(error);
      })
  }
  showPlanPrice = (row) => {
    if(typeof row['maintenance'] === 'undefined') {
      return (
        <List>
          <ListItem>
            <ListItemText
              primary='Plan type'
              secondary={<a href="http://www.carlsonsw.com/where-to-purchase/dealers/" rel="noopener noreferrer" target="_blank">Contact Sales</a>}
            />
          </ListItem>
        </List>
      );
    }
    else
      return (
        <List>
          <ListItem>
            <ListItemText
              primary='Plan type'
              secondary={row['Plan']}
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary='Price'
              secondary={row['maintenance'].toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
              }) + ' USD'}
            />
          </ListItem>
        </List>
      );
  }
  handleUpgradedFrom = (sn) => {
    if(typeof this.state.pedigree[sn] === 'undefined')
      upgradedFrom({ sn: sn })
        .then((upg) => {
          if(upg['status'] === 'true') {
            const pedigree = this.state.pedigree;
            pedigree[sn] = upg['data'];
          }
          else {
            const pedigree = this.state.pedigree;
            pedigree[sn] = [];
          }
        })
        .catch((error) => {
          console.log(error);
          const pedigree = this.state.pedigree;
          pedigree[sn] = [];
        })
  }
  addtocart = (row) => {
    if(row['Plan'] === 'Subscription') {
      if(row.current === 'true') {
        return (
          <Button
            variant='raised'
            color='primary'
            onClick={() => this.handleSubscribe(row, 'Unsubscribe')}
          >
            <Cancel /> &nbsp; Unsubscribe
          </Button>
        );
      }
      else {
        return (
          <Button
            variant='raised'
            color='primary'
            onClick={() => this.handleSubscribe(row, 'Subscribe')}
          >
            <Done /> &nbsp; Subscribe
          </Button>
        );
      }
    }
    else if(row['current'] === 'true') {
      return (
        <Typography variant='caption'>
          You already have the current version.<br />
          No upgrade needed.
        </Typography>
      );
    }
    else if(
      typeof row['maintenance'] !== 'undefined' &&
      row['maintenance'] !== ''
    ) {
      return (
        <Button
          variant='raised'
          color='primary'
          style={{ textTransform: 'none' }}
          onClick={() => this.handleAddtoCart(row)}
        >
          <FormattedMessage
            id='Add to Cart'
            defaultMessage='Add to Cart'
          />&nbsp;
          <Send />
        </Button>
      );
    }
  }
  handleSubscribe = (row, plan) => {
    this.setState({ subscribe: {
      plan: plan,
      serial: row.SERIALNUM,
      name: row.PRODUCTNAME,
      description: 'Serial: ' + row.SERIALNUM,
      quantity: 1,
      price: row.maintenance
    } });
  }
  handleAddtoCart = (row) => {
    this.props.AddToCart(row);
    this.setState( { Message: 'Added' });
  }
  handleAddAlltoCart = () => {
    for(var i = 0; i < this.state.data.length; i++)
      if(
        this.state.data[i].current === 'false' &&
        typeof this.state.data[i].maintenance === 'number'
      )
        this.props.AddToCart(this.state.data[i]);
    this.setState( { Message: 'Added' });
  }
  handleGetRegistration = (sn) => {
    if(typeof this.state.registration[sn] === 'undefined')
      getRegistration({ sn: sn })
        .then((reg) => {
          if(reg['status'] === 'true') {
            const registration = this.state.registration;
            registration[sn] = reg['data'];
            this.setState({ registration: registration });
          }
          else {
            const registration = this.state.registration;
            registration[sn] = [];
            this.setState({ registration: registration });
          }
        })
        .catch((error) => {
          console.log(error);
          const registration = this.state.registration;
          registration[sn] = [];
          this.setState({ registration: registration });
        })
  }

  render() {
    if(this.state.subscribe !== null)
      return (
        <Subscription
          subscription={this.state.subscribe}
          back={() => this.setState({ subscribe: null })}
        />
      );
    else
      return (
        <div>
          <Grid container>
            <Grid item xs={6} sm={6} md={1} lg={1} xl={1}>
              <div style={{ paddingTop: '20px' }}>
                <IconButton color='primary' onClick={() => window.print()}>
                  <img src='print.ico' alt='Print' heigth='30' width='30' />
                </IconButton>
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={1} lg={1} xl={1}>
              <div style={{ paddingTop: '20px' }}>
                <IconButton color='primary' onClick={
                  () => window.open('/report', 'report', 'menubar=no')
                }>
                  <img src='report.ico' alt='Report' heigth='30' width='30' />
                </IconButton>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={9} lg={9} xl={9} >
              <Typography variant='display1'>
                <center><font color='#385687'>
                  <FormattedMessage
                    id='Products & Plans'
                    defaultMessage='Products & Plans'
                  />
                </font></center>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={1} lg={1} xl={1}>
              <div style={{ paddingTop: '20px' }}>
                <IconButton color='primary' component={Link} to='/shoppingcart'>
                  <Badge
                    badgeContent={Object.keys(this.props.ShoppingCart).length}
                  >
                    <img src='Carlson Cart.ico' alt='Shopping Cart' heigth='30' width='30' />
                  </Badge>
                </IconButton>
              </div>
            </Grid>
          </Grid>
          <Paper>
            <ReactTable
              columns={columns}
              manual
              data={this.state.data}
              pages={this.state.pages}
              loading={this.state.loading}
              onFetchData={this.fetchData}
              defaultPageSize={10}
              className="-striped -highlight"
              SubComponent={(row) => {
                return (
                  <div className='MyProductsDetail'>
                    <Paper style={{ padding: '20px' }}>
                      <Grid container style={{ border: '1px silver solid', padding: '20px' }}>
                        <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
                          <List>
                            <ListItem>
                              <ListItemText
                                primary='Serial Number'
                                secondary={row['original']['SERIALNUM']}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText
                                primary='Modules'
                                secondary={row['original']['mod']}
                              />
                            </ListItem>
                            <ListItem>
                              <ListItemText
                                primary='Network'
                                secondary={
                                  (row['original']['NETWORKLM'] === '1') ?
                                    'Yes' : 'No'
                                }
                              />
                            </ListItem>
                          </List>
                        </Grid>
                        <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                          {this.showPlanPrice(row['original'])}
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                          {this.handleUpgradedFrom(row['original']['SERIALNUM'])}
                          <ExpansionPanel>
                            <ExpansionPanelSummary expandIcon={<ExpandMore />} style={{ backgroundColor: '#E3ECF2' }}>
                              <Typography>Upgraded From</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails style={{ backgroundColor: '#EBF5FB' }}>
                              <Typography variant='caption' style={{ textAlign: 'left', whiteSpace: 'pre-line' }}>
                                {(typeof this.state.pedigree[row['original']['SERIALNUM']]=== 'undefined') ? 'Loading...' : this.state.pedigree[row['original']['SERIALNUM']].join('\n')}
                              </Typography>
                            </ExpansionPanelDetails>
                          </ExpansionPanel>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                          {this.addtocart(row['original'])}
                        </Grid>
                        <p />
                        <div style={{ width: '100%', marginTop: '10px', backgroundColor: '#EBF5FB', color: '#707B7C' }}>
                          <ReactTable
                            columns={[
                              {
                                Header: 'Registration history',
                                columns: [
                              { Header: 'Date', accessor: 'date' },
                              { Header: 'User', accessor: 'user' }
                            ]}]}
                            showPagination={false}
                            sortable={false}
                            defaultSorted={[]}
                            minRows={0}
                            onFetchData={this.handleGetRegistration(row['original']['SERIALNUM'])}
                            loading={typeof this.state.registration[row['original']['SERIALNUM']] === 'undefined'}
                            data={this.state.registration[row['original']['SERIALNUM']]}
                          />
                        </div>
                      </Grid>
                    </Paper>
                  </div>
              )}}
            />
            <div style={{ padding: '10px' }}>
              <Button
                variant="raised"
                color="primary"
                style={{ textTransform: 'none' }}
                onClick={this.handleAddAlltoCart}
              >
                Add products listed above to shopping cart ${this.state.sum}
              </Button>
            </div>
          </Paper>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={this.state.Message !== '' || this.state.errorMessage !== ''}
            autoHideDuration={7000}
            onClose={() => {this.setState({ Message: '' })}}
            message={
              <span>
                {this.state.Message}
                <span style={{ color: 'red' }}>
                  {this.state.errorMessage}
                </span>
              </span>
            }
          />
        </div>
      );
  }
}

const mapStateToProps = (state) => {
  return {ShoppingCart: state.ShoppingCart};
}

const mapDispatchToProps = (dispatch) => ({
  AddToCart: (item) => dispatch(AddToCart(item))
});

const ProductsPlans = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

export default ProductsPlans;



// WEBPACK FOOTER //
// ./src/components/home/ProductsPlans.js